import { InjectionKey, Ref } from 'vue';

export type InjectOptions = { selectMe: () => void; label: string; ref: HTMLElement | undefined };

export const PMSelectInjectionKey = Symbol() as InjectionKey<{
  addOption: (value: string | number | boolean | undefined | null, options: InjectOptions) => void;
  removeOption: (value: string | number | boolean | undefined | null) => void;
  selectOption: (value: string | number | boolean | undefined | null) => void;
  selectedValue: Ref<string | number | boolean | undefined | null>;
  stopCloseTimer: () => void;
}>;
